export default __webpack_public_path__ + "static/gesda-website_logo-f6808c770ff415b4ffe9a41c5317bb36.png";